import { useState } from 'react';

const faqs = [
  {
    q: '麻花影视是否需要注册才能观看？',
    a: '无需注册，打开即看。麻花影视聚合全网公开影视资源，不设任何观看门槛，访问网站即可直接浏览和观看所有内容。',
  },
  {
    q: '支持哪些设备观看？',
    a: '支持手机、平板、电脑全平台观看。网页端自适应各种屏幕尺寸，同时提供 APP 客户端下载，支持离线缓存和投屏功能，随时随地畅享高清影视。',
  },
  {
    q: '影片更新频率如何？',
    a: '每日实时更新，热播剧集与各大平台同步上线。我们的智能抓取系统 24 小时不间断监测各平台最新资源，确保你第一时间看到最新内容，日均更新量超过 500 部。',
  },
  {
    q: '观看是否需要付费？',
    a: '完全免费。麻花影视聚合的是各平台公开发布的影视资源，我们仅提供便捷的聚合检索和播放服务，不向用户收取任何费用。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于麻花影视的常见疑问，这里都有答案
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 pr-4">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-200 ${openIndex === i ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg text-foreground-500"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}